var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogFormVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.paramsData,
                rules: _vm.rules,
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c(
                "el-form-item",
                {
                  key: "language",
                  staticClass: "lodingItem",
                  attrs: { prop: "language", label: _vm.$t("language") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: { placeholder: _vm.$t("pleaseChoose") },
                      model: {
                        value: _vm.paramsData.language,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "language", $$v)
                        },
                        expression: "paramsData.language"
                      }
                    },
                    _vm._l(_vm.Language, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "expires",
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "start_time",
                    rules: _vm.rules.expires,
                    label: _vm.$t("effectiveTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetimerange",
                      align: "right",
                      "range-separator": _vm.$t("range"),
                      "start-placeholder": _vm.$t("startTime"),
                      "end-placeholder": _vm.$t("endTime")
                    },
                    on: { change: _vm.searchTimeChange },
                    model: {
                      value: _vm.expires,
                      callback: function($$v) {
                        _vm.expires = $$v
                      },
                      expression: "expires"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "is_timing",
                  staticClass: "lodingItem",
                  attrs: { prop: "is_timing", label: _vm.$t("scheduledStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        placeholder: _vm.$t("pleaseSelectScheduledStatus")
                      },
                      model: {
                        value: _vm.paramsData.is_timing,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_timing", $$v)
                        },
                        expression: "paramsData.is_timing"
                      }
                    },
                    _vm._l(_vm.timingList, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.paramsData.is_timing == 1,
                      expression: "paramsData.is_timing == 1"
                    }
                  ],
                  key: "timing",
                  staticClass: "lodingItem",
                  attrs: { prop: "timing", label: _vm.$t("scheduledTime") }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1",
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      "picker-options": _vm.pickerOptionsLater,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetime",
                      placeholder: _vm.$t("pleaseSelectScheduledTime")
                    },
                    model: {
                      value: _vm.paramsData.timing,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "timing", $$v)
                      },
                      expression: "paramsData.timing"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex lodingItem-title first_box",
                  staticStyle: {
                    "margin-bottom": "20px",
                    width: "100%",
                    "align-items": "center"
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("emailContent")) + ": "),
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      staticStyle: { "padding-left": "20px" }
                    },
                    _vm._l(_vm.tagList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "addtag",
                          on: {
                            click: function($event) {
                              return _vm.addtag(item.content)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      )
                    }),
                    0
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  key: "context",
                  staticClass: "lodingItem",
                  staticStyle: { width: "100%" },
                  attrs: { prop: "context" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 12 },
                      placeholder: _vm.$t("pleaseInputContent")
                    },
                    model: {
                      value: _vm.paramsData.context,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "context", $$v)
                      },
                      expression: "paramsData.context"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }